/* Vetalus rest-of-page v0.6: CTA bands scroll to the size picker; "Full label" opens the Key Ingredients accordion. Draft theme only. */
(function(){
  if (window.__vtRest) return; window.__vtRest = true;
  function headerOffset(){
    var h = document.querySelector('header, .header-section, [id$="__header_section"]'); var off = 0;
    if (h){ var cs = getComputedStyle(h.closest('.shopify-section') || h); var r = h.getBoundingClientRect();
      if ((cs.position === 'sticky' || cs.position === 'fixed' || getComputedStyle(h).position === 'sticky' || getComputedStyle(h).position === 'fixed') && r.bottom > 0) off = r.bottom; }
    return off + 16;
  }
  function scrollToEl(el, cb){
    var y = el.getBoundingClientRect().top + window.pageYOffset - headerOffset();
    var smooth = !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    window.scrollTo({top: Math.max(0, y), behavior: smooth ? 'smooth' : 'auto'});
    if (cb) setTimeout(cb, smooth ? 700 : 0);
  }
  document.addEventListener('click', function(ev){
    var a = ev.target.closest && ev.target.closest('[data-vt-goto="plan"]');
    if (a){
      var t = document.querySelector('.vt5-plan') || document.getElementById('vt5-size-label');
      if (!t) return; ev.preventDefault();
      scrollToEl(t, function(){ var f = document.querySelector('.vt5-size[aria-checked="true"]') || document.querySelector('.vt5-size'); if (f) f.focus({preventScroll: true}); });
      return;
    }
    var b = ev.target.closest && ev.target.closest('[data-vt-open="key-ingredients"]');
    if (b){
      var acc = Array.prototype.slice.call(document.querySelectorAll('details.vt5-acc')).filter(function(d){ var s = d.querySelector('summary'); return s && /key ingredients/i.test(s.textContent); })[0];
      if (!acc) return; ev.preventDefault(); acc.open = true;
      scrollToEl(acc, function(){ var s = acc.querySelector('summary'); if (s) s.focus({preventScroll: true}); });
    }
  });
})();
